import createDocumentStoreClass from './lib/create_document_store_class';
import InboxPreviewConverter from 'scripts/adapters/immutable_converters/inbox_preview_converter';

export default createDocumentStoreClass({
  converter: InboxPreviewConverter,
});
